
<template>
  <div>
    <index-data-export></index-data-export>
  </div>
</template>

<script>

export default {
  name: 'DataExports',
  components: {
    IndexDataExport: ()=> import("@/components/data_export/IndexDataExport.vue")
  },
}
</script>
